import composeFieldName from './composeFieldName';

export const getFacetParamKey = (facet) => {
  const { legacyFacetQueryParameters } = facet?.customData || {};
  if (Object.keys(legacyFacetQueryParameters).length) {
    return Object.values(legacyFacetQueryParameters)[0].queryStringParamName;
  } else return '';
};

const getFieldNameFromFacetParamKey = (facetParamKey) => {
  const facetFieldKey = composeFieldName(facetParamKey);
  switch (facetFieldKey) {
    case 'd':
      return 'datePublished';
    default:
      return facetFieldKey;
  }
};

export const findFacetByFieldName = (fieldName, facets) => {
  if (!facets.length) return null;
  const matchingFacet = facets.find((facet) => {
    return facet.name.toLowerCase() === fieldName;
  });
  return matchingFacet ? matchingFacet : null;
};

export const findFacetByFieldName2 = (fieldName, facets) => {
  if (!facets.length) {
    return null;
  }

  const matchingFacet = facets.find((facet) => {
    const { categories } = facet;
    if (!categories || !categories.length) {
      return false;
    }
    const facetParamKey = categories[0].queryStringParamName;
    const facetFieldName = getFieldNameFromFacetParamKey(facetParamKey);
    return facetFieldName === fieldName;
  });
  return matchingFacet ? matchingFacet : null;
};

const findFacetByParamKey = (paramKey, facets) => {
  if (!facets.length) {
    return null;
  }
  const matchingFacet = facets.find((facet) => {
    const { legacyFacetQueryParameters } = facet.customData;
    if (Object.values(legacyFacetQueryParameters).length) return Object.values(legacyFacetQueryParameters)[0].queryStringParamName === paramKey;
  });
  return matchingFacet ? matchingFacet : null;
};

export default findFacetByParamKey;
